var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-row" },
    [
      _vm.modalShown
        ? _c("ModalFullScreen", {
            attrs: { title: "Scheduler" },
            on: { close: _vm.handleCancel },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "button-move ml-90" },
                        [
                          _c("UiButton", {
                            staticClass: "mt-1 flex-shrink-0",
                            attrs: {
                              variant: "secondary",
                              buttonText: "Clear Filters",
                            },
                            on: { click: _vm.clearFilters },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "items-select grid grid-cols-2 gap-4 justify-items-stretch",
                        },
                        [
                          _c(
                            "FormGroup",
                            {
                              staticClass: "w-60 mr-6 child",
                              attrs: { title: "Countries" },
                            },
                            [
                              _c("ProfileCountrySelect", {
                                attrs: { multiple: "" },
                                model: {
                                  value: _vm.filterFields.countries,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterFields, "countries", $$v)
                                  },
                                  expression: "filterFields.countries",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            { staticClass: "w-60 mr-6 child" },
                            [
                              _c("RegionInput", {
                                attrs: {
                                  countries: _vm.filterFields.countries,
                                  multiple: "",
                                },
                                model: {
                                  value: _vm.filterFields.states,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterFields, "states", $$v)
                                  },
                                  expression: "filterFields.states",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            {
                              staticClass: "w-60 mr-6 child",
                              attrs: { title: "Cities" },
                            },
                            [
                              _c("UserCityMultiselect", {
                                attrs: {
                                  country: _vm.countriesNames,
                                  state: _vm.statesNames,
                                },
                                model: {
                                  value: _vm.filterFields.cities,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterFields, "cities", $$v)
                                  },
                                  expression: "filterFields.cities",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            {
                              staticClass: "w-60 mr-6 child",
                              attrs: { title: "Titles" },
                            },
                            [
                              _c("TitlesMultiselect", {
                                model: {
                                  value: _vm.filterFields.titles,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterFields, "titles", $$v)
                                  },
                                  expression: "filterFields.titles",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            {
                              staticClass: "mr-6 w-60 flex-shrink-0 child",
                              attrs: { title: "Time Range" },
                            },
                            [
                              _c("FormDateRangePicker", {
                                attrs: { value: _vm.dateRange },
                                on: { input: _vm.handleDateRangeChange },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            {
                              staticClass: "w-60 mr-6 child",
                              attrs: { title: "Skills" },
                            },
                            [
                              _c("SkillsMultiselect", {
                                model: {
                                  value: _vm.filterFields.skills,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterFields, "skills", $$v)
                                  },
                                  expression: "filterFields.skills",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            {
                              staticClass: "w-60 child",
                              attrs: { title: "Rates" },
                            },
                            [
                              _c("InputRangeFilter", {
                                attrs: {
                                  inputClasses: "pl-7",
                                  prefix: "$",
                                  minValue: _vm.filterFields.minRate,
                                  maxValue: _vm.filterFields.maxRate,
                                },
                                on: {
                                  "update:minValue": function ($event) {
                                    return _vm.$set(
                                      _vm.filterFields,
                                      "minRate",
                                      $event
                                    )
                                  },
                                  "update:min-value": function ($event) {
                                    return _vm.$set(
                                      _vm.filterFields,
                                      "minRate",
                                      $event
                                    )
                                  },
                                  "update:maxValue": function ($event) {
                                    return _vm.$set(
                                      _vm.filterFields,
                                      "maxRate",
                                      $event
                                    )
                                  },
                                  "update:max-value": function ($event) {
                                    return _vm.$set(
                                      _vm.filterFields,
                                      "maxRate",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1864218098
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }